import axios from "axios";
import { url } from "../baseUrl";

export const AnalysisStore = {
  state: {
    all: [],
    ignores_report: [],
    includes_report: [],
    total_report: [],
    reportname: "",
    risks: []
  },
  mutations: {
    getallanalysis(state, data) {
      data.map(item => {
        let initialSubmitted = item.submit_date;
        let initialDate = initialSubmitted.split("T")[0];
        let initialTime = initialSubmitted.split("T")[1].split(".")[0];
        let date = new Date(initialDate);
        let listDate = date.toUTCString().split(" ");
        let hours = initialTime.split(":")[0];
        let mins = initialTime.split(":")[1];
        let ampm = hours >= 12 ? "p.m." : "a.m.";
        hours = hours % 12;
        hours = hours ? hours : 12;
        item.submit_date =
          listDate[2] +
          " " +
          listDate[1] +
          ", " +
          listDate[3] +
          ", " +
          hours +
          ":" +
          mins +
          " " +
          ampm;
      });
      state.all = data.map((item, index) => ({
        index: index + 1 + ".",
        id: item.id,
        description: item.file_name,
        risk_rating: item.rating,
        status: item.status,
        submitted: item.submit_date,
        vendor: item.vendor
      }));
    },
    getReportDetails(state, data) {
      let ignores_report = [];
      data.details.filter(item => {
        if (item.ignore == false) {
          ignores_report.push(item);
        }
      });

      let includes_report = [];
      data.details.filter(item => {
        if (item.ignore == true) {
          includes_report.push(item);
        }
      });

      state.ignores_report = ignores_report.map(item => ({
        id: item.id,
        severity: item.risk_rating,
        name: item.description,
        description: item.detail,
        ignore: item.ignore
      }));

      state.includes_report = includes_report.map(item => ({
        id: item.id,
        severity: item.risk_rating,
        name: item.description,
        description: item.detail,
        ignore: item.ignore
      }));

      state.total_report = data.details.map(item => ({
        id: item.id,
        severity: item.risk_rating,
        name: item.description,
        description: item.detail,
        ignore: item.ignore
      }));

      state.reportname = data.file_name;
    },
    deleteAnalysis(state, id) {
      state.all = state.all.filter(item => item.id != id);
    },
    getOverRisk(state, data) {
      let risks = [];
      data.map(item => risks.push(item.count));
      state.risks = risks;
    }
  },
  actions: {
    async getAllAnalysis(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/analysis/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getallanalysis", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteAnalysis(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/analysis/" + data.id + "/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "delete"
        })
          .then(response => {
            context.commit("deleteAnalysis", data.id);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getReport(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/analysis/" + data.id + "/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getReportDetails", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getOverRisk(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/overalrisk/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getOverRisk", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getVendors() {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/overalvendor/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    shareReport(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/sharereport/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  getters: {
    criticalCount: state => {
      let criticalReport = state.total_report.filter(
        item => !item.ignore && item.severity == 1
      );
      let criticalCount = criticalReport.length;
      return criticalCount;
    },
    highCount: state => {
      let highReport = state.total_report.filter(
        item => !item.ignore && item.severity == 2
      );
      let hightCount = highReport.length;
      return hightCount;
    },
    mediumCount: state => {
      let mediumReport = state.total_report.filter(
        item => !item.ignore && item.severity == 3
      );
      let mediumCount = mediumReport.length;
      return mediumCount;
    },
    lowCount: state => {
      let lowReport = state.total_report.filter(
        item => !item.ignore && item.severity == 4
      );
      let lowCount = lowReport.length;
      return lowCount;
    },
    ignoreCount: state => {
      // let ignoreCount = state.includes_report.length;
      return state.total_report.filter(item => item.ignore).length;
    },
    totalCount: state => {
      let totalCount = state.total_report.length;
      return totalCount;
    }
  }
};
